import { useCallback } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/toolbox-helper'

import AndroidHandler from 'utils/androidHandler'
import { PDFViewer, PDFViewerEmptyState } from 'components/PDFViewer'

const PdfViewer = () => {
  const androidHandler = AndroidHandler()

  const router = useRouter()
  const url = router.query.url as string
  const name = (router.query.name as string) ?? 'Dokumen PDF'
  const shareText = (router.query.shareText as string) ?? ''
  const shareTextWithoutUrl = shareText.replace(url, '')

  const onLeftActionClick = () => {
    historyUtils.backToApp(router.back)
  }

  const onShareActionClick = useCallback(() => {
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(`${shareTextWithoutUrl} ${url}`)
    } else {
      // check if web share feature is available on current browser
      if (navigator.share) {
        navigator
          .share({
            title: name,
            text: shareTextWithoutUrl,
            url,
          })
          .catch(console.error)
      }
    }
  }, [androidHandler, name, shareTextWithoutUrl, url])

  return (
    <>
      <Head>
        <title>{name}</title>
        <meta key="robots" name="robots" content="noindex,follow" />
        <meta key="googlebot" name="googlebot" content="noindex,follow" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>

      <div>
        <HeaderBar fixed className="z-10">
          <HeaderBarLeftAction onClick={onLeftActionClick} />
          <HeaderBarTitle>{name}</HeaderBarTitle>
          <HeaderBarRightAction type="text">
            {url && (
              <>
                <Icon
                  as="i"
                  fontSize="small"
                  className="mr-3"
                  onClick={onShareActionClick}
                >
                  share
                </Icon>
                <Link href={url} passHref>
                  <a download target="_self" className="mt-2">
                    <Icon as="i" fontSize="small">
                      download
                    </Icon>
                  </a>
                </Link>
              </>
            )}
          </HeaderBarRightAction>
        </HeaderBar>

        <div className="h-full mt-14">
          {url && <PDFViewer url={url} />}
          {!url && <PDFViewerEmptyState />}
        </div>
      </div>
    </>
  )
}

export default PdfViewer
